import { apiRoutes } from "../apiRoutes";
import waitlistAxios from "../waitlistAxios";

export const joinMailingList = async (payload) => {
  const response = await waitlistAxios.post(
    apiRoutes.MAILING_LIST_JOIN,
    payload,
  );
  return response.data;
};
